import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	line-height: 120%;
	text-align: left;
	color: #333333;

	h1 {
		font-size: 1.6em;
		font-weight: 600;
		margin-bottom: 1em;
		color: #00aeef;
	}
	h2 {
		font-size: 1.7em;
		font-weight: 300;
		margin-bottom: 1em;
		color: #00aeef;
	}
	h3 {
		font-size: 2em;
		font-weight: 300;
		margin-top: 2em;
		color: #00aeef;
	}
	h4 {
		font-size: 1.2em;
		font-weight: 600;
		margin: 2em 0;
		color: #00aeef;
	}
	h5 {
		font-size: 1.1em;
		font-weight: 600;
		margin-bottom: 0.25em;
		color: #00aeef;
	}
	ul {
		margin: 1em 0;
		margin-block-start: 0;
		margin-block-end: 0;
		padding-inline-start: 1em;
		list-style-type: disc;
		list-style-image: url('/images/icons/check.svg');
	}
	ol {
		margin: 1em 0;
		list-style-type: decimal;
	}
	li {
		margin-left: 0.5em;
		margin: 0.6em 0 0 0.5em;
	}
	a {
		color: #666666;
		text-decoration: underline;
	}
	i {
		font-style: italic;
	}
	b,
	strong {
		font-weight: 600;
	}
	p {
		font-size: 1em;
		margin: 1em 0;
		font-weight: 300;
	}
	img {
		height: auto;
		max-width: 100%;
		border-radius: 0.5em;
		width: 100%;
		margin: 0 auto;
	}
	pre,
	code {
		padding: 1em;
		background-color: #333333;
		color: white;
	}
	iframe {
		width: 100%;
		height: 40vh;
	}

	span {
		font-size: inherit !important;
	}

	* {
		color: #111111 !important;
		background: none !important;
		font-family: ${vars.fontPrimary} !important;
		line-height: 120% !important;
	}
`;
